@if (grants().length) {
  <div
    class="flex items-start gap-2.5 rounded-md border border-accent-80 bg-accent-98 px-3.5 py-3 text-sm leading-normal text-accent-20">
    <mat-icon class="shrink-0 text-accent-40">warning</mat-icon>
    <div class="flex min-w-0 flex-1 flex-col gap-2">
      <div class="flex flex-col gap-0.5">
        <strong>
          @if (admin()) {
            @if (singleGrant) {
              <ng-container i18n>Tiene una concesión activa</ng-container>
            } @else {
              <ng-container i18n>Tiene varias concesiones activas</ng-container>
            }
          } @else {
            @if (singleGrant) {
              <ng-container i18n>Tienes una concesión activa</ng-container>
            } @else {
              <ng-container i18n
                >Tienes varias concesiones activas</ng-container
              >
            }
          }
        </strong>

        @if (singleGrant; as grant) {
          <span i18n
            ><strong>{{ grant.remainingAllowance }}</strong> días de
            <strong>{{ grant.totalAllowance | number }}</strong> días
            disponibles. Vigente desde
            <strong>{{ grant.eligibleFrom | date: 'dd/MM/yyyy' }}</strong> hasta
            el <strong>{{ grant.eligibleUntil | date: 'dd/MM/yyyy' }}</strong
            >.</span
          >
        }
      </div>

      @if (admin() && singleGrant) {
        <mat-slide-toggle
          color="blue"
          labelPosition="after"
          class="rounded-md border border-background-border bg-white px-2 py-2.5"
          [checked]="!!grantId?.value"
          (change)="onUseExistingGrantChange($event.checked)">
          <ng-container i18n>Usar esta concesión</ng-container>
        </mat-slide-toggle>
      }

      @if (!singleGrant && grantId) {
        <mat-form-field
          appearance="outline"
          class="w-full rounded bg-white"
          subscriptSizing="dynamic">
          <mat-label i18n>Concesiones disponibles</mat-label>
          <mat-select [formControl]="grantId">
            @for (grant of grants(); track grant.grantId) {
              <mat-option [value]="grant.grantId" i18n>
                {{ grant.remainingAllowance }} días disponibles, vigente desde
                {{ grant.eligibleFrom | date: 'dd/MM/yyyy' }} hasta el
                {{ grant.eligibleUntil | date: 'dd/MM/yyyy' }}
              </mat-option>
            }
          </mat-select>
          @if (InputValidation.checkInputErrors(grantId)) {
            <qaroni-input-error-messages matError [fc]="grantId" />
          }
        </mat-form-field>
      }

      @if (admin() && confirmNewGrant) {
        <mat-slide-toggle
          color="blue"
          labelPosition="after"
          class="rounded-md border border-background-border bg-white px-2 py-2.5"
          [formControl]="confirmNewGrant">
          <ng-container i18n
            >Abrir una concesión nueva en paralelo</ng-container
          >
        </mat-slide-toggle>
      }
    </div>
  </div>
} @else if (missing()) {
  <div
    class="flex items-start gap-2.5 rounded-md border border-warn-80 bg-warn-95 px-3.5 py-3 text-sm leading-normal text-warn-20"
    role="alert">
    <mat-icon class="shrink-0 text-danger">error</mat-icon>
    <div class="flex min-w-0 flex-1 flex-col gap-0.5">
      <strong i18n>
        No se encuentra concesión activa para el tipo de permiso y ausencia.
      </strong>
      <span>
        @if (admin()) {
          <ng-container *qaroniRoleAccessPermission i18n
            >Crea primero la concesión desde
            <a
              class="font-semibold text-warn-20 underline"
              [routerLink]="eventsConfigUrl()"
              (click)="onGoToEventsConfig()"
              >Configuración › Eventos</a
            >
            e intenta registrar la solicitud.</ng-container
          >
        } @else {
          <ng-container i18n>
            Contacta con tu administrador para que la cree e intenta registrar
            la solicitud.
          </ng-container>
        }
      </span>
    </div>
  </div>
}
